var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-fondo d-flex a-center j-center",staticStyle:{"height":"calc(100vh - 75px)"}},[_vm._t("default",function(){return [_c('router-view',{attrs:{"telefono":_vm.model},on:{"save":_vm.saveTel}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }